import { useEffect, useState } from 'react';
import './Home.css';
import { FaAt, FaBars, FaHandPointRight } from 'react-icons/fa';
import { RiMessage2Fill } from 'react-icons/ri';
import { BiSolidMessageSquareDetail } from 'react-icons/bi';
import { IoPersonSharp } from 'react-icons/io5';
import { BsPersonWorkspace } from 'react-icons/bs';
import { saveAs } from 'file-saver';
import About from '../details/About';
import { Contact } from '../details/Contact';
import { Resume } from '../details/Resume';
import { Blog } from '../details/Blog';
import { Works } from '../details/Works';
import { MdPerson } from 'react-icons/md';
import SocialAnimate from '../sliderAndAnimations/SocialAnimate';
import SEOHelmet from '../details/SEOHelmet';
import AnimationRotate from '../sliderAndAnimations/AnimationRotate';

const Home = () => {
  const [titleIndex, setTitleIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false); // Sidebar state

  // Handle tab switch & smooth scroll
  const handleTabChange = (tab) => {
    setIsOpen(false);

    const section = document.getElementById(tab);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  // Toggle sidebar open/close
  const handleToggle = () => {
    setIsOpen((prev) => !prev);
  };

  // Download resume
  const handleDownloadResume = () => {
    fetch('/resume/Oguntoyinbo_Taiwo_Resume.pdf')
      .then((res) => res.blob())
      .then((blob) => {
        saveAs(blob, 'Oguntoyinbo-Taiwo-Resume.pdf');
      })
      .catch((err) => console.error('Download error:', err));
  };

  // Rotate profile titles
  useEffect(() => {
    const intervalId = setInterval(() => {
      setTitleIndex((prev) => (prev + 1) % 4);
    }, 5000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className="home">
      <SEOHelmet />
      <div className="container">

        {/* Sidebar */}
        <div className={`sidebar ${isOpen ? 'open' : ''}`}>
          <div className="toggle-icon" onClick={handleToggle}>
            {isOpen ? '✖' : <div><span><FaHandPointRight /></span><FaBars /></div>}
          </div>

          {!isOpen && <div className="arrow"></div>}

          {isOpen && (
            <div className="f-c box2">
              <div onClick={() => handleTabChange('about')} className="f-c">
                <IoPersonSharp className="icon" />
                <h3>ABOUT</h3>
              </div>

              <div onClick={() => handleTabChange('works')} className="f-c">
                <BsPersonWorkspace className="icon" />
                <h3>PROJECTS</h3>
              </div>

              <div onClick={() => handleTabChange('contact')} className="f-c">
                <FaAt className="icon" />
                <h3>CONTACT</h3>
              </div>

              <div onClick={() => handleTabChange('resume')} className="f-c">
                <BiSolidMessageSquareDetail className="icon" />
                <h3>RESUME</h3>
              </div>

              <div onClick={() => handleTabChange('blog')} className="f-c">
                <RiMessage2Fill className="icon" />
                <h3>BLOG</h3>
              </div>

              <div className="download">
                <button
                  className="download-resume"
                  style={{
                    margin: '20px',
                    padding: '10px 20px',
                    backgroundColor: '#6EC1c1',
                    color: 'white',
                    borderRadius: '5px',
                    border: 'inset',
                  }}
                  onClick={handleDownloadResume}
                >
                  Download Resume (.pdf)
                </button>
              </div>
            </div>
          )}
        </div>

        {/* Profile Section */}
        <div className="f-c two">
          <div className="image-container">
            <img src="/image/profile.png" alt="Profile" />
          </div>

          <div className="profile-details">
            <h1>Oguntoyinbo Taiwo K.</h1>

            <div className="titles">
              {[
                <h2 key="1">Javascript FullStack Developer</h2>,
                <h2 key="2">Project Management</h2>,
                <h2 key="3">Information Technologist</h2>,
                <h2 key="4">Printing Productions</h2>,
              ][titleIndex]}
            </div>

            <div className="social">
              <SocialAnimate />
            </div>

            <br />

            <div className="contact-me">
              <h3 onClick={() => handleTabChange('contact')}>
                CONTACT ME <MdPerson className="icon" />
              </h3>
            </div>
          </div>
        </div>

        {/* Content Sections */}
        <div className="three">
          <div className="three-container">
            <AnimationRotate />
            <div id="works" className="f-c section"><Works /></div>
            <div id="about" className="f-c section"><About /></div>
            <div id="contact" className="f-c section"><Contact /></div>
            <div id="resume" className="f-c section"><Resume /></div>
            <div id="blog" className="f-c section"><Blog /></div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Home;
